import React from 'react';
import styled, { css } from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button';
import Stars from './stars';
import TotalMaximumScore from './total-maximum-score';
import useRating from '../hooks/use-rating';

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.sectionSpacer};
  padding: 1.375rem;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    flex-direction: row;
  }
`;

const Link = styled(Button).attrs({ link: true })``;

const Label = styled.span`
  margin-right: 0;
  display: none;
  font-weight: 600;
  white-space: nowrap;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    display: block;
    margin-right: 1rem;
  }
`;

const RatingWidget = ({
  starsColor,
  openLinkToReviewsPageInTab = false,
  ratingId = null,
  ratingIds = null,
  companyId = null,
  className,
}) => {
  const {
    score,
    maximumScore,
    totalNumberOfReviews,
    linkToReviewsPage,
  } = useRating({
    ratingId,
    companyId,
    ratingIds,
  });

  if (!score || !maximumScore) {
    return null;
  }

  return (
    <div className={className}>
      <Wrapper>
        <Label>Klantenbeoordeling</Label>
        <TotalMaximumScore
          ratingIds={ratingIds}
          ratingId={ratingId}
          companyId={companyId}
        />
        <div>
          <Stars
            starsColor={starsColor}
            $starsColorBackground="black"
            ratingIds={ratingIds}
            ratingId={ratingId}
            companyId={companyId}
          />
        </div>
        <span>
          {totalNumberOfReviews && `Gebaseerd op ${totalNumberOfReviews} reviews.`}
          {linkToReviewsPage && (
            <>
              {' '}
              <Link
                to={linkToReviewsPage}
                forceLinkOpenInNewTab={openLinkToReviewsPageInTab}
              >
                Lees alle reviews
              </Link>
            </>
          )}
        </span>
      </Wrapper>
    </div>
  );
};

export default styled(RatingWidget)`
  text-align: center;
  margin: -1.375rem 0;

  ${({ $withBorder }) => $withBorder && css`
    ${Wrapper} {
      width: 100%;
      box-sizing: border-box;
      border: 1px solid ${({ theme }) => theme.grayLightColor};
    }
  `};
`;
